module.exports = __webpack_public_path__ + "static/media/newFlyers.7a13c5c6.jpeg";